import React from "react";
import { RouteProps } from "react-router-dom";
import { ListingAcf } from "../../constants/types/acf";
import { useCurrentRouteData } from "../../services/app-state";
import { colors } from "../../utils/colors";
import { ErrorBoundary } from "../organisms/ErrorBoundary";
import { OtherSupport } from "../organisms/HomeOtherSupport";
import { ListingItemContent } from "../organisms/ListingItemModal/ListingItem/ListingItemContent";
import { NotSureWhereToBegin } from "../organisms/NotSureWhereToBegin";

export const ListingTemplate: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData<ListingAcf>();

    return (
        <ErrorBoundary>
            <ListingItemContent listing={page} hideCloseButton />
            <OtherSupport />
            <NotSureWhereToBegin topColor={colors.brandMid} bottomColor={colors.white} />
        </ErrorBoundary>
    );
};
